export default __webpack_public_path__ + "static/launch-partner_HanDAO_logo@2x-4b4aa7bb1c5842dd4048d60e0d9001c4.png";